import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * SetupPage - Redirects to Home
 * The old OpenClaw setup page has been replaced.
 * Alaska AI Services doesn't use OpenClaw.
 */
export default function SetupPage() {
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center">
      <p className="text-slate-400">Redirecting...</p>
    </div>
  );
}
